import React, { useState, useLayoutEffect, createContext, useContext } from "react";
import api from "./api";


interface UserInterface {
    firstName: string
    lastName: string
    username: string
    email: string
    ddd: string
    phone: string
    isStaff: boolean
}

export interface AuthContextInterface {
    user?: UserInterface
    token?: string
    LogIn?: (username: string, password: string) => Promise<void>
    LogOut?: () => void
    isLogged: boolean
    authLoading: boolean
}

export const getToken = (username: string, password: string) => {
    return api.post("/get-token/", {username, password})
}


export const refreshToken = (refreshToken: string) => {
    return api.post("/get-token/refresh/", {refresh: refreshToken})
}

export const getMe = () => {
    return api.get("/authentication/me/")
}


const authContext = createContext<AuthContextInterface>({isLogged: false, authLoading: true});

export const AuthProvider: React.FC = ({children}) => {
    const [user, setUser] = useState<UserInterface>();
    const [token, setToken] = useState<string>();
    const [loading, setLoading] = useState<boolean>(true);
    


    const handleNewToken = (token: string) => {
        api.defaults.headers.common.Authorization = "Bearer " + token
        setToken(token)
    }

    const LogIn = (username: string, password: string) => {
        return new Promise<void>((resolve, reject): void => {
            getToken(username, password)
            .then((response) => {
                localStorage.setItem("@BManager/refresh_token", response.data.refresh)
                handleNewToken(response.data.access)
                getMe()
                .then(response => {
                    setUser(response.data)
                    resolve()
                })
                .catch(error => {
                    reject(error.response)
                })
            })
            .catch(error => {
                reject(error.response)
            })
            
        })
    }

    const LogOut = () => {
        setUser(undefined)
        setToken(undefined)
        localStorage.removeItem("@BManager/refresh_token")
    }

    useLayoutEffect(() => {
        const token = localStorage.getItem("@BManager/refresh_token")
        if (token != null) {
            setLoading(true);

            refreshToken(token)
            .then(response => {
                handleNewToken(response.data.access)
                getMe()
                .then(response => {
                    setUser(response.data)
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => setLoading(false))
            }).catch(error => {
                if (error.response.status == 401) {
                    // Token not valid anymore
                    localStorage.removeItem("@BManager/refresh_token")
                }else{
                    console.log("Error Refreshing Token")
                    console.log(error)
                }
                setLoading(false)
            })
        }else{
            setLoading(false)
        }
        
    }, [])

    return (
        <authContext.Provider value={
            { user, LogOut, LogIn, authLoading: loading, isLogged: !!user }
        }>
            {children}
        </authContext.Provider>
    )
}


// useAuth hook.
export const useAuth = () => {
    const c = useContext(authContext)
    return c
}
